import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Dropdown } from '../../../components/Dropdown';
import { FormField } from '../../../components/FormFields';
import { Alert, Check } from '../../../components/Icon';
import { Input } from '../../../components/Input';
import { Cell, List, Row } from '../../../components/List';
import { Loader } from '../../../components/Loader';
import { Modal, ModalControls } from '../../../components/Modal';
import { Well } from '../../../components/Well';
import { selectWorks } from '../../Api/selectors';
import { BPMPriceList, setVehicleProperty } from '../actions';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './BPMPriceListModal.module.css';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

const Container = styled.div`
  max-height: 80vh;
  /* width: 600px; */
  overflow-y: auto;

  .name {
    font-weight: 600;
  }
  .options-list {
    max-width: 900px;
    flex-wrap: wrap;
    .option {
      white-space: nowrap;
      width: 140px;
      overflow: hidden;
      margin: 0 6px;
    }
  }
  .version {
    border-bottom: 1px solid #ddd;
  }
`;

const ATX_FUEL_NAMES = ['Benzine', 'Diesel', 'Hybride Benzine', 'Electrisch', 'Aardgas'];
const ATX_TRANSMISSION_NAMES = ['Handmatig', 'Automatisch'];

const STATE = {
  atx_bpm_pricelist_mileage: '',
  _versions: [
    {
      name: '1.0 TSI Ambition',
      options: [
        'ABS',
        'AEB',
        'Apple Carpl./Android Auto',
        'armsteun achter',
        'armsteun voor',
        'ASR',
        'automatische airco',
        'band.sp.contr.syst.',
        'bestuurdersairbag',
        'binnensp. aut. dimmend',
        'Bluetooth telefoonvoorb.',
        'buitensp. elekt. inklapb.',
        'buitensp. elektr. + verw.',
        'buitensp. in carr. kleur',
        'buitenspiegel(s) aut.dim.',
        'c.deurv. met afst.bed.',
        'connected services',
        'cruise control',
        'DAB radio',
        'dakrails',
        'dimlichten aut.',
        'EBD',
        'elektrische ramen achter',
        'elektrische ramen voor',
        'ESP',
        'Forward Collision Warning',
        'hill hold functie',
        'hoofd airbag(s) a.',
        'hoofd airbag(s) v.',
        'in delen neerkl. achterb.',
        'keyless start',
        'knie airbag(s)',
        'LED achterlichten',
        'LED dagrijverlichting',
        'LED koplampen',
        'LED mistlampen',
        'lederen stuurwiel',
        'lederen versnellingspook',
        'lendesteunen (verstelb.)',
        'lichtmetalen velgen 16"',
        'multifunctioneel stuur',
        'multimedia-voorbereiding',
        'navigatie full map',
        'parkeersensor achter',
        'passagiersairbag',
        'regensensor',
        'rijstrooksensor',
        'ruitensproeiers verwarmb.',
        'spraakbediening',
        'startblokkering',
        'stoel best. hoogte verst.',
        'stoel pass. hoogte verst.',
        'stuurbekrachtiging',
        'voll. dig. instr. paneel',
        'zij airbag(s) v.',
      ],
      page: 1,
      index: 0,
    },
    {
      name: '1.0 TSI Business Edition',
      options: [
        'ABS',
        'AEB',
        'Apple Carpl./Android Auto',
        'armsteun achter',
        'armsteun voor',
        'ASR',
        'automatische airco',
        'band.sp.contr.syst.',
        'bestuurdersairbag',
        'binnensp. aut. dimmend',
        'Bluetooth telefoonvoorb.',
        'buitensp. elekt. inklapb.',
        'buitensp. elektr. + verw.',
        'buitensp. in carr. kleur',
        'buitenspiegel(s) aut.dim.',
        'c.deurv. met afst.bed.',
        'connected services',
        'cruise control',
        'DAB radio',
        'dakrails',
        'dimlichten aut.',
        'draadloze telefoonlader',
        'EBD',
        'elektr. bed. achterkl.',
        'elektrische ramen achter',
        'elektrische ramen voor',
        'ESP',
        'Forward Collision Warning',
        'hill hold functie',
        'hoofd airbag(s) a.',
        'hoofd airbag(s) v.',
        'in delen neerkl. achterb.',
        'keyless start',
        'knie airbag(s)',
        'LED achterlichten',
        'LED dagrijverlichting',
        'LED koplampen',
        'LED mistlampen',
        'lederen stuurwiel',
        'lederen versnellingspook',
        'lendesteunen (verstelb.)',
        'lichtmetalen velgen 16"',
        'multifunctioneel stuur',
        'multimedia-voorbereiding',
        'navigatie full map',
        'parkeersensor achter',
        'parkeersensor voor',
        'passagiersairbag',
        'regensensor',
        'rijstrooksensor',
        'ruitensproeiers verwarmb.',
        'spraakbediening',
        'startblokkering',
        'stoel best. hoogte verst.',
        'stoel pass. hoogte verst.',
        'stuurbekrachtiging',
        'vermoeidheids herkenning',
        'voll. dig. instr. paneel',
        'zij airbag(s) v.',
      ],
      page: 1,
      index: 1,
    },

    {
      name: '1.0 TSI Business Edition Plus',
      options: [
        'ABS',
        'AEB',
        'airco separaat achter',
        'Apple Carpl./Android Auto',
        'armsteun achter',
        'armsteun voor',
        'ASR',
        'automatische airco',
        'band.sp.contr.syst.',
        'bestuurdersairbag',
        'binnensp. aut. dimmend',
        'Bluetooth telefoonvoorb.',
        'buitensp. elekt. inklapb.',
        'buitensp. elektr. + verw.',
        'buitensp. in carr. kleur',
        'buitenspiegel(s) aut.dim.',
        'chroom delen ext.',
        'connected services',
        'cruise control adaptief',
        'DAB radio',
        'dakrails',
        'dimlichten aut.',
        'dodehoek detectie',
        'draadloze telefoonlader',
        'EBD',
        'elektr. bed. achterkl.',
        'elektrische ramen achter',
        'elektrische ramen voor',
        'ESP',
        'extra getint glas',
        'Forward Collision Warning',
        'hill hold functie',
        'hoofd airbag(s) a.',
        'hoofd airbag(s) v.',
        'in delen neerkl. achterb.',
        'keyless entry',
        'keyless start',
        'knie airbag(s)',
        'koplampreiniging',
        'LED achterlichten',
        'LED dagrijverlichting',
        'LED koplampen',
        'LED mistlampen',
        'lederen stuurwiel',
        'lederen versnellingspook',
        'lendesteunen (verstelb.)',
        'lichtmetalen velgen 17"',
        'multifunctioneel stuur',
        'multimedia-voorbereiding',
        'navigatie full map',
        'parkeersensor achter',
        'parkeersensor voor',
        'passagiersairbag',
        'regensensor',
        'rijstrooksensor',
        'ruitensproeiers verwarmb.',
        'spraakbediening',
        'startblokkering',
        'stoel best. hoogte verst.',
        'stoel pass. hoogte verst.',
        'stuurbekrachtiging',
        'vermoeidheids herkenning',
        'verwarmde voorstoelen',
        'voll. dig. instr. paneel',
        'zij airbag(s) v.',
      ],
      page: 1,
      index: 2,
    },
  ],
};

/* eslint-disable react/prefer-stateless-function */
class BPMPriceListModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      loading: false,
      atx_bpm_pricelist_mileage: props.vehicle.atx_bpm_pricelist_mileage,
    });
  }

  componentDidMount() {
    //this.props.step1(this.callback(this.step1Result.bind(this)));
  }

  //   getFuelName() {
  //     let fuel = this.props.vehicle.fuel_name;

  //     const keyPairs = {
  //       //vindat : hexon
  //       diesel: 'Diesel',
  //       electric: 'Electrisch',
  //       elektrisch: 'Electrisch',
  //       'electric/diesel': 'Hybride Benzine',
  //       'electric/gasoline': 'Hybride Benzine',
  //       benzine: 'Benzine',
  //       lpg: 'Aardgas',
  //     };

  //     for (let key in keyPairs) {
  //       if (key.toLocaleLowerCase() == (fuel + '').toLocaleLowerCase()) {
  //         return keyPairs[key];
  //       }
  //     }

  //     debugger;
  //   }
  getVersionResult(result) {
    if (!result.data?.length) this.setState({ error: 'no_data' });
    this.setState({ loading: false, versions: result.data });
  }

  initGetVersion(result) {
    this.setState({ loading: 'versions', error: null });
    this.props.getVersion(
      {
        action: 'getVersions',
        vehicle: this.props.vehicle,
      },
      this.callback(this.getVersionResult.bind(this)),
    );
  }

  render() {
    return (
      <ModalComponent title={this.lbl('vehicle.bpm.pricelist.title')} onClose={this.props.onCancel}>
        <Container className={styles.container}>
          {this.renderBody()}
          <div className="mt-2">
            <ButtonComponent style="ButtonSoftDelete" onClick={this.props.onCancel}>
              {this.lbl('cancel')}
            </ButtonComponent>
          </div>
        </Container>
      </ModalComponent>
    );
  }

  renderBody() {
    const vehicle = this.props.vehicle;
    if (this.state.getBpmResult) return <Container>{this.renderBpmResult()}</Container>;
    if (this.state.loading || this.props.loading)
      return <Loader label={`${this.state.loading == 'versions' ? 'varianten ophalen, dit kan even duren...' : ''}`} />;
    if (this.state.error) return <Well error>{this.lbl(`vehicle.bpm.pricelist.error${this.state.error}`)}</Well>;
    if (this.state.versions) return <Container>{this.renderVersions()}</Container>;
    return (
      <Container>
        {this.renderFuelName()}
        {this.renderTransmissionName()}
        {this.renderMileage()}
        {this.props.vehicle.fuel_type && this.props.vehicle.transmission_type && this.props.vehicle.mileage ? (
          <Well left>
            <HBox vCenter center>
              {/* <strong>{this.lbl('vehicle.property.bpmPricelistVersion')}</strong> */}
              {vehicle.bpmPricelistVersion ? vehicle.bpmPricelistVersion : null}
              <Button className={styles.button} onClick={this.initGetVersion.bind(this)}>
                {this.lbl('vehicle.bpm.pricelist.select.version')}
              </Button>
            </HBox>
          </Well>
        ) : null}
      </Container>
    );
  }

  renderFuelName() {
    let name = this.props.vehicle.fuel_type;
    if (!name)
      return (
        <Well warning>
          <Alert />
          {this.lbl('vehicle.property.fuel_type')}
        </Well>
      );

    return (
      <Well>
        <Check />
        {this.lbl('vehicle.property.fuel_type')}
        <br />
        {name}
      </Well>
    );
    //let name = this.props.vehicle.atx_bpm_fuel_name;

    //let name = this.getFuelName();

    let options = ATX_FUEL_NAMES.map(f => ({ label: f, value: f }));

    console.dir(this.state.selectedAtxBpmFuelName);

    return (
      <Well>
        <VBox>
          {this.lbl('vehicle.bpm.pricelist.fuelname.select')}
          <HBox center vCenter>
            <Dropdown
              options={options}
              onChange={value => this.setState({ selectedAtxBpmFuelName: value })}
              value={this.state.selectedAtxBpmFuelName || options.find(option => option.value == name)}
            />
            <Button
              disabled={!this.state.selectedAtxBpmFuelName}
              onClick={() =>
                this.props.setVehicleProperty('atx_bpm_fuel_name', this.state.selectedAtxBpmFuelName?.value, result => {})
              }
            >
              {this.lbl('save')}
            </Button>
          </HBox>
        </VBox>
      </Well>
    );
  }

  renderTransmissionName() {
    let name = this.props.vehicle.transmission_type;
    if (!name)
      return (
        <Well warning>
          <Alert />
          {this.lbl('vehicle.property.transmission_type')}
        </Well>
      );

    return (
      <Well>
        <Check />
        {this.lbl('vehicle.property.transmission_type')}
        <br />
        {name}
      </Well>
    );

    //let name = this.props.vehicle.atx_bpm_transmission_name;

    let options = ATX_TRANSMISSION_NAMES.map(f => ({ label: f, value: f }));

    console.dir(this.state.selectedAtxBpmTransmissionName);

    return (
      <Well>
        <VBox>
          {this.lbl('vehicle.bpm.pricelist.transmission.select')}
          <HBox center vCenter>
            <Dropdown
              options={options}
              onChange={value => this.setState({ selectedAtxBpmTransmissionName: value })}
              value={this.state.selectedAtxBpmTransmissionName || options.find(option => option.value == name)}
            />
            <Button
              disabled={!this.state.selectedAtxBpmTransmissionName}
              onClick={() =>
                this.props.setVehicleProperty(
                  'atx_bpm_transmission_name',
                  this.state.selectedAtxBpmTransmissionName?.value,
                  result => {},
                )
              }
            >
              {this.lbl('save')}
            </Button>
          </HBox>
        </VBox>
      </Well>
    );
  }

  renderMileage() {
    //render
    let value = this.props.vehicle.mileage;
    if (!value)
      return (
        <Well warning>
          <Alert />
          {this.lbl('vehicle.property.mileage')}
        </Well>
      );

    return (
      <Well>
        <Check />
        {this.lbl('vehicle.property.mileage')}
        <br />
        {value}km
      </Well>
    );

    //let value = this.state.atx_bpm_pricelist_mileage;
    return (
      <Well>
        <HBox center vCenter>
          <FormField label={this.lbl('vehicle.property.mileage')}>
            <Input
              name="atx_bpm_pricelist_mileage"
              placeholder={this.state.atx_bpm_pricelist_mileage}
              value={value}
              onChange={this.onInputChange.bind(this)}
            />
            <Button
              onClick={() =>
                this.props.setVehicleProperty('atx_bpm_pricelist_mileage', this.state.atx_bpm_pricelist_mileage)
              }
              disabled={!value?.length || value == this.props.vehicle.atx_bpm_pricelist_mileage}
            >
              {this.lbl('save')}
            </Button>
          </FormField>
        </HBox>
      </Well>
    );
  }

  renderVersions() {
    return (
      <VBox>
        {this.state.versions.map((version, index) => (
          <VBox className="version" onClick={() => this.setState({ [`open_${index}`]: !this.state[`open_${index}`] })}>
            <HBox vCenter>
              <div key={`${version.index}-${version.page}`}>
                <span className="name">{version.name}</span>
              </div>
              <Button
                className={styles.button}
                onClick={() => {
                  this.setState({ loading: 'getBpm' });
                  this.props.setVersion(version, result => {
                    debugger;
                    this.setState({ loading: null, getBpmResult: result });
                  });
                }}
              >
                {this.lbl('select')}
              </Button>
            </HBox>
            {this.state[`open_${index}`] ? (
              <HBox className="options-list" left>
                {version.options.map(option => (
                  <div className="option" key={`o-${index}-${option.name}`}>
                    {option}
                  </div>
                ))}
              </HBox>
            ) : null}
          </VBox>
        ))}
      </VBox>
    );
  }

  renderBpmResult() {
    if (this.state.getBpmResult.data.error) {
      return <Well error>Error</Well>;
    }
    return (
      <List>
        <Row>
          {Object.keys(this.state.getBpmResult.data).map(name => (
            <Row key={name}>
              <Cell>{name}</Cell>
              <Cell>{this.state.getBpmResult.data[name]}</Cell>
              <Cell>{this.renderBpmResultCellOptions(name, this.state.getBpmResult.data[name])}</Cell>
            </Row>
          ))}
        </Row>
      </List>
    );
  }

  renderBpmResultCellOptions(name, value) {
    if (env.clientId !== AppClientId.INDEWAL && name === 'BPMKoerslijst_RestBPM') {
      return this.state.restBPMSet ? (
        <Check />
      ) : (
        <Button
          className={styles.button}
          onClick={() => {
            this.props.setVehicleProperty('rest_bpm', value, () => {
              this.setState({ restBPMSet: true });
            });
          }}
        >
          Set RestBPM
        </Button>
      );
    }

    if (name === 'brutoBPMBedrag' && env.clientId === AppClientId.INDEWAL) {
      return this.renderSetButton(name, 'indication_gross_bpm', value, false);
    }

    if (
      env.clientId === AppClientId.INDEWAL &&
      (name == 'BPMAfschrijvingstabel_ResBPM' || name == 'BPMKoerslijst_RestBPM')
    ) {
      const lowestBPM =
        this.state.getBpmResult.data['BPMKoerslijst_RestBPM'] > this.state.getBpmResult.data['BPMAfschrijvingstabel_ResBPM']
          ? 'BPMAfschrijvingstabel_ResBPM'
          : 'BPMKoerslijst_RestBPM';

      if (lowestBPM === name) {
        return this.renderSetButton(lowestBPM, 'indication_rest_bpm', value);
      }
    }
    return name;
  }

  renderSetButton(name, propertyName, propertyValue, isRest = true) {
    return this.state[`${name}Set`] ? (
      <Check />
    ) : (
      <Button
        onClick={() => {
          this.props.setVehicleProperty(propertyName, propertyValue, () => {
            this.setState({ [`${name}Set`]: true });
          });
        }}
      >
        {`Set ${isRest ? 'Indication_Rest_BPM' : 'Indication_Gross_BPM'}`}
      </Button>
    );
  }
}

BPMPriceListModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWorks([REQUEST_VEHICLE_PROPERTY_UPDATE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getVersion(data, callback) {
      dispatch(BPMPriceList(data, callback));
    },
    setVersion(version, callback) {
      dispatch(BPMPriceList({ action: 'getBpm', vehicle: ownProps.vehicle, version }, callback));
    },
    setVehicleProperty(name, value, cb) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, name, value, cb));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const BPMPriceListModal = compose(withConnect, withRouter)(BPMPriceListModalComp);
